<template lang="pug">
  apollo-query(
    :query="query"
    :variables="{ id: curriculumId }"
    :fetchPolicy="fetchPolicy"
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      .loading(v-if="loading")
        slot(name="loading")
          loading-indicator
      .loaded(v-else)
        slot(name="loaded" :curriculum="curriculum" v-if="curriculum")
          loading-indicator

</template>

<script>
import { FETCH_CURRICULUM_QUERY } from '@/graphql'
import createCurriculum from '@/entities/Curriculum'

export default {
  props: {
    curriculumId: { type: String, required: true },
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_CURRICULUM_QUERY,
      curriculum: null,
    }
  },
  methods: {
    onResult(result) {
      this.curriculum = createCurriculum({
        ...result.data.viewer.curriculum,
      })
    },
  },
}
</script>
